import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { getCardById } from '../../use';
import { useStorymapStore } from '../../useModule';
import { FlashJustDragged } from '../moveCard/flashJustDragged';

const { registerReducer, dispatch } = useStorymapStore();

export class CancelCardTitleEditing extends Action<StorymapState> {
    public static ACTION_TYPE = 'CancelCardTitleEditing';

    public constructor(public id: string) {
        super(CancelCardTitleEditing.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CancelCardTitleEditing): void => {
    const card = getCardById(action.id);

    if (card) {
        card.isTitleEditing = false;

        dispatch(new FlashJustDragged());
    }
};

//@ts-ignore
registerReducer(CancelCardTitleEditing.ACTION_TYPE, reducer);
